const Hero = () => {
  return (
    <div className="bg-[#E7F2F5] flex flex-col items-center justify-center md:h-[524px] text-[30px] md:text-[72px] text-hColor">
      <h1>Powerful features for</h1>
      <h1>smarter fleet management</h1>
    </div>
  );
};

export default Hero;
